import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Linkedin, Heart } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const Logo = () => (
    <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" width="50" height="50">
      <defs>
        <linearGradient id="footerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:'#06b6d4', stopOpacity:1}} />
          <stop offset="50%" style={{stopColor:'#8b5cf6', stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:'#ec4899', stopOpacity:1}} />
        </linearGradient>
      </defs>
      <rect x="10" y="10" width="25" height="25" fill="url(#footerGrad)" opacity="0.7" rx="5"/>
      <rect x="45" y="10" width="25" height="25" fill="url(#footerGrad)" opacity="0.5" rx="5" transform="rotate(10 57.5 22.5)"/>
      <rect x="10" y="45" width="25" height="25" fill="url(#footerGrad)" opacity="0.5" rx="5" transform="rotate(-10 22.5 57.5)"/>
      <rect x="45" y="45" width="25" height="25" fill="url(#footerGrad)" opacity="0.7" rx="5"/>
      <circle cx="40" cy="40" r="16" fill="white"/>
      <path d="M 32 40 L 37 45 L 49 33" stroke="url(#footerGrad)" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <motion.div
              className="footer-brand"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Link to="/" className="footer-logo">
                <Logo />
                <span className="footer-logo-text">Mixality</span>
              </Link>
              <p className="footer-tagline">
                AI-augmented QA services for small companies.
                Ship with confidence — starting at $300.
              </p>
              <div className="footer-social">
                <a
                  href="https://linkedin.com/company/mixality"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </motion.div>

            <motion.div
              className="footer-links"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h4>Services</h4>
              <ul>
                <li><a href="#services">QA Automation Audit</a></li>
                <li><a href="#services">Playwright Smoke-Test Starter</a></li>
              </ul>
            </motion.div>

            <motion.div
              className="footer-links"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li>
                  <a href="mailto:mrichard.hudson@mixality.com?subject=Free Discovery Call">
                    Book a Call
                  </a>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>© {currentYear} Mixality. All rights reserved.</p>
              <p className="footer-made">
                Made with <Heart size={14} className="heart-icon" /> in Calgary, AB
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
